import { SelectInput } from '../baseInputs'

const CHARGING_OPTIONS = [
  {
    label: 'On my driveway - I have a charger installed',
    value: 'On my driveway - I have a charger installed',
  },
  {
    label: 'On my driveway - I need a charger installed',
    value: 'On my driveway - I need a charger installed',
  },
  {
    label: 'Public charging only',
    value: 'Public charging only',
  },
]

type Props = {
  helper?: string
  optional?: boolean
}

const ChargingPreference = ({ helper, optional }: Props) => {
  const name = 'charging_preference'
  const label = 'How do you expect to charge your car?'

  return (
    <SelectInput
      name={name}
      label={label}
      options={CHARGING_OPTIONS}
      helper={helper}
      optional={optional}
    />
  )
}

export default ChargingPreference
